import { EntranceIllustration } from '../../assets/illustrations';
import styles from './style.module.scss';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    fullScreenMode?: boolean;
    childWrapperClassName?: string;
};

export default function Entrance(props: Props) {
    const {
        children,
        fullScreenMode,
        childWrapperClassName,
    } = props;

    return (
        <div className={styles.container}>
            <div
                className={styles.entranceBody}
                data-is-full-screen={fullScreenMode}
            >
                <div className={`${styles.child} ${childWrapperClassName || ''}`}>
                    {children}
                </div>
                {!fullScreenMode && <div className={styles.illustration}>
                    <EntranceIllustration />
                    <span className={styles.illustration_slogan}>
                        Creating equal opportunities in recruitment
                    </span>
                </div>}
            </div>
        </div>
    );
};
